import React from 'react';
import { Link } from 'react-router-dom';

const OrderHeader = () => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Link to="/admin/orders" className="text-[#174540] hover:text-[#0d2926]">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </Link>
          <h1 className="text-2xl font-bold text-gray-900">Nouvelle Commande</h1>
        </div>
        
        <Link
          to="/admin/orders"
          className="text-sm font-medium text-[#174540] hover:text-[#0d2926]"
        >
          Retour à la liste
        </Link>
      </div>
      
      <p className="mt-2 text-sm text-gray-700">
        Créez une nouvelle commande en remplissant le formulaire ci-dessous.
      </p>
      
      <div className="mt-4 bg-blue-50 border-l-4 border-blue-400 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-blue-700">
              Les champs marqués d'un astérisque (*) sont obligatoires. Les totaux seront calculés automatiquement à partir des articles.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;